import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';
import { CodeSubmission } from './types';

// THIN-7269: this endpoint moved from document-service to provider-service
// alongside the FSM-aware ICD10_EDIT cascade. The old document-service path
// (POST /document/form/edit-icd-codes) was removed in favor of the
// provider-service orchestrator, which writes the ICD10_EDIT audit row,
// cascades UNSIGN_PHYSICIAN / UNSIGN when signatures are present, and calls
// document-service's in-document primitive for the JSON / PDF work.
//
// Wire shape: only the ICD codes go in the body. The DOR's IP address is
// passed through the X-Forwarded-For header (matches the other signature
// endpoints in provider-service); signatureStatus / supervisorStatus from
// the legacy payload are derived BE-side from the form-sub's current state
// and no longer need to be sent.
export const submitIcdCodes = async (
  realm: string,
  formSubmissionUuid: string,
  facilityId: string,
  payload: CodeSubmission
) => {
  const token = await getAccessToken();

  return fetch(
    `${baseApiUrl}/provider/signature/icd10-edit?formSubmissionUuid=${formSubmissionUuid}`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'x-tenant-id': realm,
        Facility_id: facilityId,
        'X-Forwarded-For': payload.ipAddress ?? '',
      },

      // Wire field names are camelCase to match the Lombok-derived Jackson
      // property names on the BE Icd10EditRequest (Java fields are
      // Icd10TreatmentCodes / Icd10MedicalCodes, which Jackson decapitalizes
      // for the wire). The legacy ICD10TMedicalCodes field (Jotform-era T) is
      // dropped entirely on the wire.
      body: JSON.stringify({
        icd10TreatmentCodes: payload.icd10TreatmentCodes,
        icd10MedicalCodes: payload.icd10TMedicalCodes,
      }),
    }
  )
    .then((response) => {
      return response.json();
    })
    .then((responseObj) => {
      return {
        ...responseObj.data,
        error: responseObj.code === 'OK' ? false : responseObj.message,
      };
    })
    .catch((error) => {
      throw Error(`Error fetching ICD10 codes: ${error}`);
    });
};
